export default function intersect(value, other) {
    const obj = {};
    Object.keys(value).forEach(key => {
        if (value[key] === other[key])
            obj[key] = value[key];
    });
    return obj;
}
//# sourceMappingURL=intersect.js.map